module.exports = __webpack_public_path__ + "components/media-kit/static/chris-9b5a99ecef9bdd3d2a464f1a7ee77015.png";